export const METADATA_MAP = {
  calendar_category_id: 'key1',
  organizer_email: 'key2',
  scene_card_id: 'key3',
  original_timezone: 'original_timezone'
};
